import React from "react";
import { StyleSheet, View } from "react-native";
import { BottomBarDLSType, ButtonTypeDLS, ColorTokens, FontFamilyTokens, FontSizeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import ThemeProvider from "@voltmoney/theme";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import CustomHeader from "../../customHeader/CustomHeader";
import BottomBar from "../../bottomBarDLS/bottomBarDLS";
import { Typography } from "../../typography/Typography";
import { addCommasToNumber } from "../utils";
import AccordionListItem from "./Accordian";
const RepaymentChargesDetailPages = ({ height, goBackAction, needHelpAction, triggerAction, bankData }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const header = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomHeader, { title: '', goBackAction: goBackAction, needHelpAction: needHelpAction, triggerAction: triggerAction })));
    };
    const renderCardDivider = () => {
        return (React.createElement(View, { style: {
                borderTopWidth: 1,
                borderColor: '#EFEFEF',
                width: '100%'
            } }));
    };
    const calculateTotalOutstandingInterest = () => {
        // @ts-ignore
        let creditData = bankData;
        // @ts-ignore
        return creditData.penalInterestAccruedNotDue || 0 + creditData.outstandingInterest || 0 + creditData.interestAccruedNotDue || 0;
    };
    const calculateTotalOutstandingCharged = () => {
        // @ts-ignore
        let creditData = bankData;
        // @ts-ignore
        return creditData.outstandingCharges || 0 + creditData.totalNotionalChargesAndDematBounce || 0;
    };
    const ChargesCard = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    paddingTop: 16,
                    paddingBottom: 16,
                    paddingRight: 16
                } },
                React.createElement(Typography, { label: 'Outstanding principal', typeDLS: TypographyTypeDLS.B1R }),
                React.createElement(Typography
                // @ts-ignore
                , { 
                    // @ts-ignore
                    label: '₹' + addCommasToNumber(bankData.outstandingPrincipal), typeDLS: TypographyTypeDLS.B1B })),
            React.createElement(View, null,
                React.createElement(AccordionListItem, { id: '', title: 'Total outstanding in interest', subTitle: `₹${addCommasToNumber(calculateTotalOutstandingInterest())}`, paddingVertical: 16, paddingHorizontal: 0, childBodyStyle: {
                        padding: 0,
                        paddingLeft: 16,
                        paddingRight: 16
                    } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingVertical: 16
                        } },
                        React.createElement(Typography, { label: 'Outstanding Interest', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: `₹${addCommasToNumber(bankData.outstandingInterest)}`, fontWeight: '500', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingVertical: 16,
                            paddingLeft: -16,
                        } },
                        React.createElement(Typography, { label: 'Interest accured not due', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: '₹' + addCommasToNumber(bankData.interestAccruedNotDue), fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
                React.createElement(AccordionListItem, { id: '', title: 'Total outstanding charges', subTitle: `₹${addCommasToNumber(calculateTotalOutstandingCharged())}`, paddingVertical: 16, paddingHorizontal: 0, childBodyStyle: {
                        padding: 0,
                        paddingLeft: 16,
                        paddingRight: 16
                    } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingVertical: 16,
                            paddingLeft: -16,
                        } },
                        React.createElement(Typography, { label: 'Outstanding charges', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: '₹' + addCommasToNumber(bankData.outstandingCharges), fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 16 } },
                        React.createElement(Typography, { label: 'Total Demat and bounce charged', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: '₹ ' + addCommasToNumber(bankData.totalNotionalChargesAndDematBounce), fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
                bankData.penalInterestReceivable && bankData.penalInterestReceivable !== "0" &&
                    React.createElement(React.Fragment, null,
                        renderCardDivider(),
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', padding: 16 } },
                            React.createElement(Typography, { label: 'Penal interest receivable', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(Typography
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                label: `-₹ ${addCommasToNumber(bankData.penalInterestReceivable)}`, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter }))),
                (bankData.excessMargin != null && bankData.excessMargin !== 0.00) &&
                    React.createElement(React.Fragment, null,
                        renderCardDivider(),
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingVertical: 16,
                                paddingRight: 16
                            } },
                            React.createElement(Typography, { label: 'Excess margin', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(Typography
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                label: `-₹${addCommasToNumber(bankData.excessMargin)}`, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter }))),
                bankData.advanceInterest !== 0.00 &&
                    React.createElement(React.Fragment, null,
                        renderCardDivider(),
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingVertical: 16,
                                paddingRight: 16
                            } },
                            React.createElement(Typography, { label: 'Advance interest', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(Typography
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                label: `-₹ ${addCommasToNumber(bankData.advanceInterest)}`, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter }))),
                bankData.tdsreceivable && bankData.tdsreceivable !== "0" &&
                    React.createElement(React.Fragment, null,
                        renderCardDivider(),
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingVertical: 16,
                                paddingRight: 16
                            } },
                            React.createElement(Typography, { label: 'TDS receivable', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(Typography
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                label: `-₹ ${addCommasToNumber(bankData.tdsreceivable)}`, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter }))),
                renderCardDivider(),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingVertical: 16,
                        paddingRight: 16
                    } },
                    React.createElement(Typography, { label: 'Net dues payable', fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: '₹' + addCommasToNumber(bankData.netPayable), fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })))));
    };
    const body = () => {
        return (React.createElement(View, { style: styles.bodyContainer },
            React.createElement(Typography, { label: 'Outstanding amount & charges', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night }),
            ChargesCard()));
    };
    const footer = () => {
        return (React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLabel: 'Ok, got it!', btnTypeDLS: ButtonTypeDLS.PRIMARY, onPress: () => {
                goBackAction &&
                    triggerAction(goBackAction);
            }, isPositionAbsolute: false }));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: React.createElement(React.Fragment, null, header()), bottomChildren: React.createElement(React.Fragment, null, footer()) },
        React.createElement(React.Fragment, null, body())));
};
const styles = StyleSheet.create({
    bodyContainer: {
        padding: 16
    }
});
export default RepaymentChargesDetailPages;
